import { gql } from "graphql-request";

export const GET_REFUNDS_ANALYTICS = gql`
  query RefundsAnalytics($input: RefundsAnalyticsInput) {
    refundsAnalytics(input: $input) {
      data {
        summary {
          totalLeads
          verifiedLeads
          leadsWithAnalysis
          totalUploadCount
          totalRefundIdentified
          averageRefundPerLead
          leadsWithLiquidationData
        }
        leads {
          email
          firstName
          lastName
          company
          verified
          verifiedAt
          funnelStep
          uploadCount
          latestTotalRefund
          latestEntryCount
          latestHasLiquidationData
          source
          utmSource
          utmMedium
          utmCampaign
          referrer
          createdAt
          updatedAt
        }
        leadsMeta {
          total
          pageNo
          pageSize
        }
        eventCounts {
          event
          count
        }
        funnel {
          step
          count
        }
        topCompanies {
          company
          leadCount
          totalRefund
        }
      }
      error
    }
  }
`;

export const DELETE_REFUNDS_LEAD = gql`
  mutation DeleteRefundsLead($email: String!) {
    deleteRefundsLead(email: $email) {
      success
      error
    }
  }
`;
